import { HttpPostFunction } from "@lookiero/sty-psp-http";
import {
  IsSalesOfferingEnabledView,
  ViewIsSalesOfferingEnabledResult,
} from "../../../projection/offering/viewIsSalesOfferingEnabled";

interface ViewIsSalesOfferingEnabledResponse {
  readonly active: boolean;
}

interface HttpSalesOfferingEnabledView extends IsSalesOfferingEnabledView {}

interface HttpSalesOfferingEnabledViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpSalesOfferingEnabledViewFunction {
  (args: HttpSalesOfferingEnabledViewFunctionArgs): HttpSalesOfferingEnabledView;
}

const httpSalesOfferingEnabledView: HttpSalesOfferingEnabledViewFunction =
  ({ httpPost }) =>
  async ({ signal }) =>
    await httpPost<ViewIsSalesOfferingEnabledResponse, ViewIsSalesOfferingEnabledResult>({
      endpoint: "/sales/v1/has-access",
      body: {},
      signal,
      result: {
        error: false,
        success: (response) => response?.active ?? false,
      },
    });

export { httpSalesOfferingEnabledView };
